import React, { Component } from 'react';
import S from './phaseHistory.scss';
import PropTypes from 'prop-types';
import CheckStyle from 'styles/checkbox.scss';

class HistoryFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSortByDateTime: true,
      showSpotBot: true,
      onlyComms: false,
    };
  }

  changeSortOrder = () => this.setState({
    isSortByDateTime: !this.state.isSortByDateTime,
  }, () => this.props.toggleSortByDateTime());


  changeShowSpotBot = () => {
    const { onlyComms, showSpotBot } = this.state;
    const checkBoxes = { showSpotBot: !showSpotBot };

    if (onlyComms && showSpotBot) checkBoxes.onlyComms = false;

    this.setState(checkBoxes, this.props.toggleEventFilters(checkBoxes));
  }

  changeOnlyComms = () => {
    const { onlyComms, showSpotBot } = this.state;
    const checkBoxes = { onlyComms: !onlyComms };

    if (!onlyComms && !showSpotBot) checkBoxes.showSpotBot = true;

    this.setState(checkBoxes, this.props.toggleEventFilters(checkBoxes));
  }


  render() {
    return (
      <div className={S.phaseHistorySortContainer}>
        <div className={S.phaseHistorySortDirection}>
          Group By Status <input
            type="checkbox"
            className={CheckStyle.check}
            checked={!this.state.isSortByDateTime}
            onChange={() => this.changeSortOrder()}
          />
        </div>
        <div className={S.phaseHistorySortDirection}>
          Remove Spotbot Events <input
            type="checkbox"
            className={CheckStyle.check}
            checked={!this.state.showSpotBot}
            onChange={() => this.changeShowSpotBot()}
          />
        </div>
        <div className={S.phaseHistorySortDirection}>
          Show Only Communication Events <input
            type="checkbox"
            className={CheckStyle.check}
            checked={this.state.onlyComms}
            onChange={() => this.changeOnlyComms()}
          />
        </div>
      </div>
    );
  }

}

HistoryFilters.propTypes = {
  toggleSortByDateTime: PropTypes.func,
  toggleEventFilters: PropTypes.func,
};

export default HistoryFilters;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/historyFilters.jsx